import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    servicios: [
      { to: '/grabado-laser-asturias', label: 'Grabado Láser' },
      { to: '/impresion-3d-asturias', label: 'Impresión 3D' },
      { to: '/regalos-personalizados-asturias', label: 'Regalos Personalizados' },
      { to: '/proyecto-personalizado', label: 'Proyectos Personalizados' },
    ],
    empresa: [
      { to: '/quienes-somos', label: 'Quiénes Somos' },
      { to: '/servicios', label: 'Servicios' },
      { to: '/trabajos', label: 'Nuestros Trabajos' },
      { to: '/preguntas-frecuentes', label: 'Preguntas Frecuentes' },
      { to: '/contacto', label: 'Contacto' },
    ],
    legal: [
      { to: '/privacidad', label: 'Política de Privacidad' },
      { to: '/cookies', label: 'Política de Cookies' },
      { to: '/terminos', label: 'Términos y Condiciones' },
    ],
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__main">
        <div className="footer__container">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <img 
                src="/assets/Logo_texto_lado.png" 
                alt="Artelaser3D - Grabado Láser e Impresión 3D en Asturias" 
                className="footer__logo-img"
                width="200"
                height="60"
              />
            </Link>
            <p className="footer__description">
              Expertos en grabado láser e impresión 3D en Asturias. 
              Transformamos tus ideas en realidad con precisión y creatividad. 
              Servicio profesional para particulares y empresas.
            </p>
          </div>

          <div className="footer__links">
            <div className="footer__column">
              <h4 className="footer__column-title">Servicios</h4>
              <ul className="footer__column-list">
                {footerLinks.servicios.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="footer__link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__column">
              <h4 className="footer__column-title">Empresa</h4>
              <ul className="footer__column-list">
                {footerLinks.empresa.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="footer__link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__column">
              <h4 className="footer__column-title">Contacto</h4>
              <address className="footer__address">
                <p>Asturias, España</p>
                <p><a href="mailto:info@artelaser3d.es">info@artelaser3d.es</a></p>
                <p className="footer__phones">
                  <a href="tel:632393838">632 39 38 38</a> - Láser (Antonio)<br />
                  <a href="tel:646371648">646 37 16 48</a> - Impresión 3D (Pablo)
                </p>
                <p className="footer__hours">
                  <strong>Horario:</strong><br />
                  Lunes - Viernes: 9:00 - 18:00
                </p>
              </address>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__container">
          <p className="footer__copyright">
            © {currentYear} Artelaser3D. Todos los derechos reservados.
          </p>
          <div className="footer__legal">
            {footerLinks.legal.map((link) => (
              <Link key={link.to} to={link.to} className="footer__legal-link">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
